import React from "react";
import * as R from "ramda";
import { Icon, Tooltip, Input } from "antd";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";

import styled from "styled-components/macro";

const Container = styled.div`
  width: 350px;
  margin-bottom: 3em;
  .row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

function UniversityConfig({ value, onChange }) {
  const { t } = useTranslation();
  return (
    <Container>
      <div className="row">
        <p>{t("vinculations:universities.redirect")}</p>
        <Tooltip
          placement="rightTop"
          title={t("vinculations:universities.help")}
        >
          <Icon type="question-circle"></Icon>
        </Tooltip>
      </div>
      <Input
        value={value}
        onChange={e => onChange(e.target.value)}
        type="url"
        placeholder="https://uba.com/login"
      />
    </Container>
  );
}

export default connect(state => ({
  loginUrl: R.path(["company", "loginUrl"], state)
}))(UniversityConfig);
